import { IKhamDoan, AddHopDong } from "../models/KhamDoanModel";

export const initialValuesKhamDoan: IKhamDoan = {
  contractName: "",
  companyName: "",
  address: "",
  taxNumber: "",
  contactPerson: "",
  referenceName: "",
  referenceEmail: "",
  paymentMethod: {
    id:"",
    name:""
  },
  contractValue: 0,
  startDate: "",
  endDate: "",
  paymentMethodName:"",
  paymentMethodId:"",
};

export const initialValuesThemHD: AddHopDong = {
  contractName: "",
  companyName: "",
  address: "",
  taxNumber: "",
  contactPerson: "",
  referenceName: "",
  referenceEmail: "",
  paymentMethod: undefined,
  contractValue: null,
  startDate: "",
  endDate: "",
  paymentMethodName:"",
  paymentMethodId:"",
  note:""
};

export const KEY_TAB_THONG_TIN_HD = {
  QL_HOP_DONG: "0",
  KHAM_LAM_SANG: "1",
  THANH_TOAN: "2",
};

export const columnThongTinGoiKham = [
  { title: "TT", field: "status", className: "spaces w-5 text-center" },
  { title: "Tên dịch vụ", field: "name", className: "spaces w-30" },
  {
    title: "Số lượng",
    field: "svcUnit",
    className: "spaces w-10 text-center",
    render: (rowData: any) => {
      const DEFAULT_QUANTITY = 1;
      return DEFAULT_QUANTITY;
    }
  },
  {
    title: "Ghi chú",
    field: "amount",
    className: "spaces w-20 text-center"
  },
  {
    title: "Kết luận",
    field: "obs.value",
    className: "spaces w-20"
  },
  {
    title: "Đối tượng",
    field: "svcPriceClone",
    className: "spaces w-15"
  }
];

export const columnsThongTinXetNghiem = [
  { title: "Tên xét nghiệm", field: "name", className: "spaces width-40" },
  {
    title: "SL",
    field: "quantity",
    className: "spaces width-10 text-center",
    render: (rowData: any) => {
      const DEFAULT_QUANTITY = 1;
      return DEFAULT_QUANTITY;
    }
  },
  {
    title: "Kết quả",
    field: "ketQua",
    className: "spaces width-20",
    render: (rowData: any) => {
      return rowData?.obs?.value || "";
    }
  },
  { title: "Loại bệnh phẩm", field: "type", className: "spaces width-15" },
  { title: "Ghi chú", field: "note", className: "spaces width-15" }
];

export const valueStatus = {
  DANG_KHAM:"dangKham",
  DA_KHAM_XONG:"daKhamXong",
  DUYET_BENH_AN:"duyetBenhAn",

}

export const WF_STATUS = {
  CHUA_DEN_KHAM: {
    CODE: 'not_examined',
    NAME: 'Chưa đến khám',
  },
  DA_DEN_KHAM: {
    CODE: 'examined',
    NAME: 'Đã đến khám',
  },
  CHUA_KHAM: {
    CODE: 'clinical_new',
    NAME: 'Chưa đến khám',
  },
  DANG_KHAM: {
    CODE: 'clinical_start',
    NAME: 'Đang khám',
  },
  DA_KHAM_XONG: {
    CODE: 'enough_result',
    NAME: 'Đã khám xong',
  },
  DA_CO_KQ: {
    CODE: 'clinical_result_order',
    NAME: 'Đã có kết quả',
  },
  KET_THUC_KHAM: {
    CODE: 'clinical_conclusion',
    NAME: 'Kết thúc khám',
  },
  DUYET_BENH_AN: {
    CODE: 'returned',
    NAME: 'Duyệt bệnh án',
  }
}

export const TYPE_RECEIPT = {
  PHIEU_THU: 'PHIEU_THU',
  TAM_UNG: 'TAM_UNG',
  PHIEU_HOAN: "PHIEU_HOAN"
}

export const filterDateList = [
  { label: "Ngày bắt đầu", type: 1, name: "filterStartDate" },
  { label: "Ngày kết thúc", type: 2, name: "filterEndDate"  }
];

export const GIOI_TINH_KHAM_DOAN = [
	{ id: 0, name: 'Tất cả' },
	{ id: 1, name: 'Nam' },
	{ id: 2, name: 'Nữ' },
	{ id: 3, name: 'Không xác định' },
];

export const EXPORT_CONTRACT_REPORT_ID = "1467b9c0-b3e6-2eb1-c0ae-e9e397cbc576";

export const TAB_CODE = {
  TAB_NOI_DUNG: "noiDung",
  TAB_TIEN_SU_BENH: "tienSuBenh",
  TAB_KHAM_NGOAI: "khamNgoai",
  TAB_KHAM_NOI: "khamNoi",
  TAB_KHAM_MAT: "khamMat",
  TAB_KHAM_RANG_HAM_MAT: "khamRangHamMat",
  TAB_KHAM_TAI_MUI_HONG: "khamTaiMuiHong",
  TAB_KHAM_DA_LIEU: "khamDaLieu",
  TAB_KHAM_SAN_PHU_KHOA: "khamSanPhuKhoa",
  TAB_CHI_SO_DAC_THU: "chiSoDacThu",
  TAB_KHAM_SANG_LOC: "khamSangLoc",
  TAB_KET_LUAN: "ketLuanKhamDoan",
};